import { lazy } from 'react';
// import Teste from '../../Test/pages/teste';

const MyArea = lazy(() => import('../pages'));
const SchoolPerformance = lazy(() => import('../pages/SchoolPerformance'));

export const MyAreaRoutes = [
  {
    path: '/',
    element: <MyArea />,
  },
  {
    path: '/minha-area',
    element: <MyArea />,
  },
  {
    path: '/meu-desempenho',
    element: <SchoolPerformance />,
  },
];
